import React, { useState } from "react";
import { Alert, Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Checkbox } from "semantic-ui-react";

const FrontOfficeModal = (props) => {
    const { t } = useTranslation();
    const { onClose, onProceed, cancellationWindow } = props;
    const [checked, setChecked] = useState(false);

    return (
        <Modal show={true} onHide={onClose} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{t("information")}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-3">
                <Alert variant="primary">
                    <p className="text-bold">{t("attention")}!</p>
                    <p>
                        {t("frontOfficeModal.txt1")} {cancellationWindow}{" "}
                        {t(
                            `${
                                cancellationWindow === 1
                                    ? "cancellationWindow1hour"
                                    : (cancellationWindow >= 2 && cancellationWindow) <= 4 || cancellationWindow === 24
                                    ? "cancellationWindow2-4hours"
                                    : "cancellationWindowHours"
                            }`
                        )}{" "}
                        {t("frontOfficeModal.txt1a")}
                    </p>
                    <p className="mt-4 text-bold">{t("important")}!</p>
                    <p className="mb-1">{t("frontOfficeModal.txt2")}</p>
                    <p>
                        <strong className="text-uppercase">{t("frontOfficeModal.txt3")}</strong>
                        {t("frontOfficeModal.txt4")}
                    </p>
                </Alert>
                <Checkbox
                    label={<label className="form-label">{t("acknowledgeWithInfo")}</label>}
                    id="acknowledgeWithInfo"
                    checked={checked}
                    onChange={() => setChecked(!checked)}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={onClose}>
                    {t("close")}
                </Button>
                <Button variant="primary" onClick={onProceed} disabled={!checked}>
                    {t("dontShowAgain")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default FrontOfficeModal;
